export { default } from './RecentlyReturnedLoading';



// WEBPACK FOOTER //
// ./app/components/borrowing/recentlyreturned/RecentlyReturnedLoading/index.js